import TextComponent from './Text'
import FormGroupComponent from './FormGroup'
import SelectComponent from './Select'
import TextareaComponent from './Textarea'
import RadioComponent from './Radio'
import CheckboxComponent from './Checkbox'

export const Text = TextComponent
export const FormGroup = FormGroupComponent
export const Select = SelectComponent
export const Textarea = TextareaComponent
export const Radio = RadioComponent
export const Checkbox = CheckboxComponent


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Form/index.js